import React from 'react';
import { CheckCircle } from 'lucide-react';
interface PurchaseNotificationProps {
  name: string;
  city: string;
  product: string;
  isVisible: boolean;
  isHeader?: boolean;
}
export function PurchaseNotification({
  name,
  city,
  product,
  isVisible,
  isHeader = false
}: PurchaseNotificationProps) {
  if (isHeader) {
    return <div className={`flex items-center gap-2 transition-all duration-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4 pointer-events-none'}`} data-id="element-10">
        <div className="bg-orange-500 p-1 rounded-full flex-shrink-0" data-id="element-11">
          <CheckCircle className="w-3 h-3 text-white" data-id="element-12" />
        </div>
        <div className="min-w-0" data-id="element-13">
          <p className="text-[10px] md:text-xs font-bold text-white" data-id="element-14">
            <span className="text-orange-400" data-id="element-15">{name}</span> de {city}
          </p>
          <p className="text-[9px] md:text-[10px] text-blue-200 font-medium" data-id="element-16">
            acaba de adquirir: <span className="text-white" data-id="element-17">{product}</span>
          </p>
        </div>
      </div>;
  }
  return <div className={`fixed left-4 z-30 transform transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'} 
      bottom-4`} data-id="element-18">
      <div className="bg-[#0a1120] rounded-xl p-4 flex items-center gap-3 border-2 border-orange-500 shadow-xl max-w-sm" data-id="element-19">
        <div className="bg-orange-500/20 p-2 rounded-full flex-shrink-0" data-id="element-20">
          <CheckCircle className="w-6 h-6 text-orange-500" data-id="element-21" />
        </div>
        <div data-id="element-22">
          <p className="text-sm font-bold text-white" data-id="element-23">
            <span className="text-orange-400" data-id="element-24">{name}</span> de{' '}
            <span className="text-orange-400" data-id="element-25">{city}</span>
          </p>
          <p className="text-xs text-gray-300 font-medium mt-0.5" data-id="element-26">
            acaba de adquirir: <span className="text-white" data-id="element-27">{product}</span>
          </p>
          <p className="text-[10px] text-gray-500 mt-1" data-id="element-28">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}